/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";

function run(Component, rest) {
  function renderComponent(t, props, isAuth, logout, deleteAccount, language, i18n) {
    let currentPath = props.location.pathname
      .substring(1)
      .toUpperCase()
      .split("/")[0];
    /*
    if (currentPath === "SELECTMISSIONAFTERLOGIN"){
      currentPath = "SELECTMISSION"
    }
    // console.log(currentPath);*/
    //set language Data
    const languageObj = t(currentPath, { returnObjects: true });
    return (
      <Component
        {...props}
        i18n={i18n}
        logout={logout}
        deleteAccount={deleteAccount}
        language={language}
        languageObj={languageObj}
        RenderFullPageLoading={RenderFullPageLoading}
      />
    );
  }
  return (
    <AuthConsumer>
      {({ t, isAuth, logout, deleteAccount, language, i18n }) => (
        <Route
          render={(props) =>
            isAuth ? (
              renderComponent(t, props, isAuth, logout, deleteAccount, language, i18n)
            ) : (
              <Redirect to="/LoginPrompt" />
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

const ProtectedRoute = ({ component: Component, ...rest }) =>
  run(Component, rest);

export default ProtectedRoute;
